<template>
    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
        <path
            d="M5.37422 16.6236C4.74444 17.2542 3.66666 16.8082 3.66666 15.917V11.9167H7.6707C8.56138 11.9167 9.00765 12.9934 8.37814 13.6235L7.13441 14.8684C8.15187 15.9088 9.54475 16.4967 11 16.5C13.3278 16.4966 15.4014 15.0281 16.1773 12.8334H16.1938C16.2988 12.5351 16.3782 12.2284 16.4312 11.9167H18.2756C17.8136 15.5833 14.6956 18.3333 11 18.3334H10.9908C9.04636 18.3392 7.18039 17.5668 5.80891 16.1884L5.37422 16.6236ZM5.56782 10.0834H3.72349C4.18526 6.41817 7.30124 3.66867 10.9954 3.66666H11C12.9448 3.66044 14.8112 4.43289 16.1828 5.8117L16.6271 5.36854C17.2574 4.73981 18.3333 5.18625 18.3333 6.07654V10.0834H14.3319C13.4409 10.0834 12.9948 9.00592 13.625 8.37604L14.8702 7.1317C13.8516 6.09004 12.4568 5.502 11 5.50003C8.67216 5.50347 6.5986 6.972 5.82266 9.1667H5.80616C5.70033 9.46472 5.61997 9.77145 5.56782 10.0834Z"
            fill="white" />
    </svg>
</template>

<script>
export default {
    name: 'RefreshIconWhite'
}
</script>